export default "__VITE_ASSET__36ed29b6__"